import styled from '@emotion/styled';
import { media } from '../../styles/media';
import { Button } from '../../components/button';

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
    text-align: center;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    max-width: 600px;
    width: 100%;
`;

export const Title = styled.h1`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 700;
    color: #10307b;
    margin: 0;
    
    ${media.max('md')} {
        font-size: 48px;
    }
    
    ${media.min('md')} {
        font-size: 60px;
    }
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 400px;
`;

export const Text = styled.p`
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 18px;
    line-height: 1.6;
    color: #666666;
    margin: 0;
    
    ${media.max('md')} {
        font-size: 16px;
    }
    
    ${media.min('md')} {
        font-size: 20px;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 40px;
    width: 100%;
`;

export const StyledButton = styled(Button)`
    padding: 12px 24px;
    font-size: 18px;
    border-radius: 8px;
    
    ${media.max('md')} {
        padding: 10px 20px;
        font-size: 16px;
    }
`;
